<div [formGroup]="form">
	<div class="form-row-container">
		@if ((isMidScreenOrSmaller() | async)) {
			<div class="vertical">
				<div class="question-label label-row">{{ 'estimate-questions.' + product.accreditationBody + '.' + question.questionId + '.title' | translate }}</div>
				<div class="additional-question-label">{{ 'estimate-questions.' + product.accreditationBody + '.' + question.questionId + '.label' | translate }}</div>
				<div class="question-options horizontal">
					<input type="text" style="display: none" [name]="formControlName()"
						   [formControlName]="formControlName()" [attr.formcontrolname]="formControlName()" nbInput>
					@for (optionId of question.optionIds; track optionId; let isLast = $last) {
						<div
							[ngClass]="{'question-option': true, 'vertical': true, 'with-margin': !isLast, 'selected': isSelected(optionId), 'invalid': isInvalid(formControlName()), 'disabled': isDisabled()}"
							(click)="chooseOption(optionId)">
							<span class="text" [innerHTML]="'estimate-questions.' + product.accreditationBody + '.' + optionId | translate"></span>
						</div>
						@if (optionId === chosenAttachedQuestionOptionId || isSelected(optionId)) {
							<div class="attached-question-wrapper">
								@for (attachedQuestion of question.attachedQuestions; track trackByEstimateQuestionFn($index, attachedQuestion)) {
									@if (attachedQuestion && attachedQuestionVisible(attachedQuestion, question.chosenOptionIds, question.optionIds)) {
										<div style="margin-bottom: 15px;"
										>
											@if (attachedQuestion.questionType == 'TEXT') {
												<div>
                            <textarea class="attached-question-description" #description
									  [id]="'estimate-question-' + question.type.toLowerCase() + '-' + product.standard.name.toLowerCase() + '-' + attachedQuestion.type.toLowerCase()"
									  [placeholder]="attachedQuestion.question" type="text" nbInput fullWidth
									  [formControlName]="attachedQuestionFormControlName(attachedQuestion.type)"
									  [attr.formcontrolname]="attachedQuestionFormControlName(attachedQuestion.type)"
									  [ngClass]="{'invalid' : isInvalid(attachedQuestionFormControlName(attachedQuestion.type))}"
									  (keyup)="autoGrow(description)">
                            </textarea>
													@if (translationExists(attachedQuestion.type)) {
														<translation-field
															[standard]="product.standard.name"
															[translationSubject]="translationSubject(attachedQuestion.type)"
															[translatedText]="getTranslationText(attachedQuestion.type)"
															[previewMode]="true"></translation-field>
													}
												</div>
											}
											@if (attachedQuestion.questionType == 'RADIO') {
												<div>
													<div class="form-row radio-button-row attached-question">
														<div class="form-input radio-button-group">
															<nb-radio-group
																[id]="'estimate-question-' + question.type.toLowerCase() + '-' + product.standard.name.toLowerCase() + '-' + attachedQuestion.type.toLowerCase()"
																[name]="attachedQuestionFormControlName(attachedQuestion.type)"
																[status]="isInvalid(attachedQuestionFormControlName(attachedQuestion.type)) ? 'danger' : 'primary'"
																[formControlName]="attachedQuestionFormControlName(attachedQuestion.type)"
																[attr.formcontrolname]="attachedQuestionFormControlName(attachedQuestion.type)"
																(valueChange)="updateFormControl(attachedQuestionFormControlName(attachedQuestion.type), $event)"
																[disabled]="shouldDisableRadio(attachedQuestionFormControlName(attachedQuestion.type))">
																<nb-radio name="yes"
																		  [value]="true">{{ 'common.yes' | translate }}
																</nb-radio>
																<nb-radio name="no"
																		  [value]="false">{{ 'common.no' | translate }}
																</nb-radio>
															</nb-radio-group>
														</div>
														<div class="attached-question-name">
															{{ attachedQuestion.question }}
														</div>
													</div>
												</div>
											}
											@if (isInvalid(attachedQuestionFormControlName(attachedQuestion.type))) {
												<div class="validation-message"
												>{{ getValidationErrors(attachedQuestionFormControlName(attachedQuestion.type)) | async }}
												</div>
											}
										</div>
									}
								}
							</div>
						}
					}
				</div>
				@if (isInvalid(formControlName())) {
					<div class="validation-message"
					>{{ getValidationErrors(formControlName()) | async }}
					</div>
				}
			</div>
		}

		@if (!(isMidScreenOrSmaller() | async)) {
			<div>
				<div class="vertical">
					<div class="question-label label-row">{{ 'estimate-questions.' + product.accreditationBody + '.' + question.questionId + '.title' | translate }}</div>
					<div class="additional-question-label">{{ 'estimate-questions.' + product.accreditationBody + '.' + question.questionId + '.label' | translate }}</div>
					<div class="question-options horizontal">
						<input type="text" style="display: none" [name]="formControlName()"
							   [formControlName]="formControlName()" [attr.formcontrolname]="formControlName()" nbInput>
						@for (optionId of question.optionIds; track optionId; let isLast = $last) {
							<div [attr.data-test-id]="'question-option-' + question.questionId + '-' + optionId"
								 [ngClass]="{'question-option': true, 'vertical': true, 'with-margin': !isLast, 'selected': isSelected(optionId), 'invalid': isInvalid(formControlName()), 'disabled': isDisabled()}"
								 (click)="chooseOption(optionId)">
								<span class="text" [innerHTML]="'estimate-questions.' + product.accreditationBody + '.' + optionId | translate"></span>
							</div>
						}
					</div>
					@if (isInvalid(formControlName())) {
						<div class="validation-message"
						>{{ getValidationErrors(formControlName()) | async }}
						</div>
					}
				</div>
				@for (attachedQuestion of question.attachedQuestions; track trackByEstimateQuestionFn($index, attachedQuestion)) {
					@if (attachedQuestion && attachedQuestionVisible(attachedQuestion, question.chosenOptionIds, question.optionIds)) {
						<div style="margin-bottom: 15px;"
						>
							@if (attachedQuestion.questionType == 'TEXT') {
								<div>
                      <textarea class="attached-question-description" #description
								[id]="'estimate-question-' + question.type.toLowerCase() + '-' + product.standard.name.toLowerCase() + '-' + attachedQuestion.type.toLowerCase()"
								[attr.data-test-id]="'attached-question-option-' + question.questionId"
								[placeholder]="attachedQuestion.question" type="text" nbInput fullWidth
								[formControlName]="attachedQuestionFormControlName(attachedQuestion.type)"
								[attr.formcontrolname]="attachedQuestionFormControlName(attachedQuestion.type)"
								[ngClass]="{'invalid' : isInvalid(attachedQuestionFormControlName(attachedQuestion.type))}"
								(keyup)="autoGrow(description)">
                      </textarea>
									@if (translationExists(attachedQuestion.type)) {
										<translation-field
											[standard]="product.standard.name"
											[translationSubject]="translationSubject(attachedQuestion.type)"
											[translatedText]="getTranslationText(attachedQuestion.type)"
											[previewMode]="true">
										</translation-field>
									}
								</div>
							}
							@if (attachedQuestion.questionType == 'RADIO') {
								<div>
									<div class="form-row radio-button-row attached-question">
										<div class="form-input radio-button-group">
											<nb-radio-group
												[id]="'estimate-question-' + question.type.toLowerCase() + '-' + product.standard.name.toLowerCase() + '-' + attachedQuestion.type.toLowerCase()"
												[attr.data-test-id]="'radio-question-option-' + question.questionId"
												[name]="attachedQuestionFormControlName(attachedQuestion.type)"
												[status]="isInvalid(attachedQuestionFormControlName(attachedQuestion.type)) ? 'danger' : 'primary'"
												[formControlName]="attachedQuestionFormControlName(attachedQuestion.type)"
												[attr.formcontrolname]="attachedQuestionFormControlName(attachedQuestion.type)"
												(valueChange)="updateFormControl(attachedQuestionFormControlName(attachedQuestion.type), $event)"
												[disabled]="shouldDisableRadio(attachedQuestionFormControlName(attachedQuestion.type))">
												<nb-radio name="yes" [value]="true">{{ 'common.yes' | translate }}</nb-radio>
												<nb-radio name="no" [value]="false">{{ 'common.no' | translate }}</nb-radio>
											</nb-radio-group>
										</div>
										<div class="attached-question-name">
											{{ attachedQuestion.question }}
										</div>
									</div>
								</div>
							}
							@if (isInvalid(attachedQuestionFormControlName(attachedQuestion.type))) {
								<div class="validation-message"
								>{{ getValidationErrors(attachedQuestionFormControlName(attachedQuestion.type)) | async }}
								</div>
							}
						</div>
					}
				}
			</div>
		}

	</div>
</div>
